import React from 'react';
import {
  Text,
} from '@fluentui/react-northstar';
import { ApprovalCard } from './TicketRequestCard';
import { TablePagination } from '../../../shared/components/table/TablePagination';
import { useHistory } from 'react-router-dom';
import { MyWorkListViewType, TicketApprovalState } from '../../../shared/utils/constants';
import { useTranslation } from 'react-i18next';
import { useSetState } from '../../../AppState';
import { ResultCount } from '../../../shared/components/ResultCount';
import { RefreshBar } from '../../../shared/components/table/RefreshBar';

interface Props {
  paginatedApprovals: any[],
  column: number,
  userId: number,
  pagination: {
    currentPage: number,
    totalCount: number,
    moveToPage: (type: string) => void,
    itemPerPage: number,
    itemsPerPageChanged?: (itemPerPage: number) => void
  }
  onUpdate: (approvalId: number, approverId: number, status: TicketApprovalState, approvalState: TicketApprovalState) => void
  /** Reloading in place: the cards stay, dimmed, under the loading bar - inside the scroll box, so it stops at the
      scrollbar as the other columns' bars do. */
  refreshing?: boolean
}

export const ApprovalColumn = ({ paginatedApprovals, column, userId, pagination, onUpdate, refreshing }: Props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const setAppState = useSetState();

  return (
    <>
      <div className={`overflow-auto request-column-ticket md:request-column-ticket${refreshing ? ' cards-refreshing' : ''}`}>
        {refreshing && <RefreshBar />}
        {/* Keyed by approval: the card keeps its own copy of the approval, so by position a search or Show Closed
            drew the previous approval in a card for a frame, and its approver line kept the old status. */}
        {paginatedApprovals.map((ticketApproval: any) => (
          <div key={ticketApproval.Id} onClick={() => {
            setAppState(prev => ({ ...prev, selectedTaskOrApproval: { type: MyWorkListViewType.Approvals, id: ticketApproval.TicketId } }));
            history.push(`/requests/${ticketApproval.TicketId}`)
          }} className='cursor-pointer'>
            <ApprovalCard key={ticketApproval.Id} ticket={ticketApproval.Ticket} view='list' approvalProps={{ approval: ticketApproval, userId: userId }} onUpdate={onUpdate} />
          </div>
        ))}
      </div>
      <div className={`flex items-center${refreshing ? ' cards-refreshing' : ''}`}>
        <ResultCount count={pagination.totalCount} />
        <TablePagination currentPage={pagination.currentPage} totalCount={pagination.totalCount} moveToPage={pagination.moveToPage} itemsPerPage={pagination.itemPerPage} itemsPerPageChanged={pagination.itemsPerPageChanged} />
      </div>
    </>
  )
}